import { BaseService } from '../base';

export type InsuredObjectType = {
  id: string;
  code: string;
  description: string;
};

export type InsuredObjectTypesMeta = {
  pageNumber: number;
  pageSize: number;
  total: number;
  totalPages: number;
};

export type InsuredObjectTypesResponse = {
  data: InsuredObjectType[];
  meta: InsuredObjectTypesMeta;
};

export type GetInsuredObjectTypesParams = {
  sortType?: 'ASC' | 'DESC';
  sortField?: string;
  pageSize?: number;
  pageNumber?: number;
};

export class InsuredObjectsService extends BaseService {
  constructor() {
    super(import.meta.env.VITE_API_URL);
  }

  async getInsuredObjects(): Promise<{
    success: boolean;
    data?: InsuredObjectTypesResponse;
    error?: string;
  }> {
    try {
      const path = `/portal/v1/products/product-lines/homeowner/insured-objects?`;
      const response = await this.get(path);

      return await this.handleJsonResponse<InsuredObjectTypesResponse>(
        response
      );
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar tipos do objeto segurado',
      };
    }
  }
}

export const insuredObjectsService = new InsuredObjectsService();
